/**
 * Encabezado de la DataTable Pedimento
 */
export const headerPedimentoDataTable = document.getElementById("pedimento-descarga-uno-a-uno");
